import { inject, Injector, Signal, TemplateRef } from '@angular/core';
import { Dismissed, ResolvableModalConfig } from '../types/modal-config';
import { ModalService } from '../modal.service';
import { NumpadModalComponent } from '../components/numpad-modal/numpad-modal.component';

export interface NumpadModalConfig {
  title?: string | Signal<string | null>;
  subtitle?: string | Signal<string | null>;
  text?: string | Signal<string | null>;
  content?: TemplateRef<any> | Signal<TemplateRef<any> | null>;
  contentContext?: object | Signal<object | null>;
  showCancel?: boolean;
  class?: string;
  dismiss?: boolean;
  value: number | Signal<number>;
  quickNumbers?: number[] | Signal<number[]>;
  unit?: string | null;
  heightPx?: number;
  min?: number;
  max?: number;
  floatingPoints?: number;
  selectExistingInput?: boolean;
  dismissOnNavigation?: boolean;
}

async function numpad<T>(
  modalService: ModalService,
  config: NumpadModalConfig,
  injector: Injector
): Promise<number | Dismissed> {
  const modalConfig: ResolvableModalConfig<NumpadModalComponent, number> = {
    component: NumpadModalComponent,
    dismiss: config.dismiss ?? true,
    title: config.title,
    subtitle: config.subtitle,
    priority: Number.POSITIVE_INFINITY,
    class: config.class,
    injector: injector,
    data: {
      value: config.value,
      quickNumbers: config?.quickNumbers ?? [],
      unit: config?.unit ?? null,
      heightPx: config?.heightPx,
      min: config?.min,
      max: config?.max,
      floatingPoints: config?.floatingPoints,
      selectExistingInput: config?.selectExistingInput,
    },
    dismissOnNavigation: config.dismissOnNavigation ?? true,
  };
  return await modalService.open(modalConfig);
}

export function numpadFn(): <T>(
  config: NumpadModalConfig
) => Promise<number | Dismissed> {
  const modalService = inject(ModalService);
  const injector = inject(Injector);
  return (config) => numpad(modalService, config, injector);
}
